const translations_zh_CN = {
    'mc.serverCore.title': 'Minecraft 服务端核心下载',
    'mc.serverCore.welcome': '欢迎使用 MSL 的服务端镜像下载服务！',
    'mc.serverCore.description': '选择适合您的 Minecraft 服务器核心，支持插件、模组、原版等多种类型。',
    'mc.serverCore.categories': '服务端分类',
    'mc.serverCore.selectType': '选择您需要的服务端类型',
    'mc.serverCore.selectCore': '选择服务端核心',
    'mc.serverCore.searchCore': '搜索服务端核心...',
    'mc.serverCore.versionList': '版本列表',
    'mc.serverCore.selectVersion': '选择版本',
    'mc.serverCore.refresh': '刷新',
    'mc.serverCore.startSelect': '开始选择服务端',
    'mc.serverCore.selectCategoryFirst': '请先选择一个服务端分类来查看可用的核心。',
    'mc.serverCore.selectCoreFirst': '请先选择一个服务端核心',
    'mc.serverCore.server': '服务端',
    'mc.serverCore.version': '版本',
    'mc.serverCore.fileVerification': '文件校验信息',
    'mc.serverCore.downloadStarted': '下载已开始',
    'mc.serverCore.getCategoryFailed': '获取服务端分类失败',
    'mc.serverCore.networkError': '网络错误，请稍后重试',
    'mc.serverCore.getVersionsFailed': '获取版本列表失败',
    'mc.serverCore.networkErrorVersions': '获取版本列表时网络错误',
    'mc.serverCore.getDownloadLinkFailed': '获取下载链接失败',
    'mc.serverCore.networkErrorDownload': '下载时网络错误',
    'mc.serverCore.coreCount': '个核心',
    'mc.serverCore.loadingVersions': '加载版本中...',
    'mc.serverCore.noVersionsFound': '未找到可用版本。',

    // 服务端分类
    'mc.serverCore.pluginsCore': '插件服务端',
    'mc.serverCore.pluginsCoreDesc': '支持 Bukkit/Spigot/Paper 插件的服务端核心。',
    'mc.serverCore.pluginsAndModsCore_Forge': 'NeoForge 系混合服务端',
    'mc.serverCore.pluginsAndModsCore_ForgeDesc': '同时支持 NeoForge/Forge 模组和插件的混合服务端。',
    'mc.serverCore.pluginsAndModsCore_Fabric': 'Fabric 混合服务端',
    'mc.serverCore.pluginsAndModsCore_FabricDesc': '同时支持 Fabric 模组和插件的混合服务端。',
    'mc.serverCore.modsCore_Forge': 'NeoForge 系模组服务端',
    'mc.serverCore.modsCore_ForgeDesc': '专门用于运行 NeoForge/Forge 模组的服务端核心。',
    'mc.serverCore.modsCore_Fabric': 'Fabric 模组服务端',
    'mc.serverCore.modsCore_FabricDesc': '专门用于运行 Fabric 模组的服务端核心。',
    'mc.serverCore.vanillaCore': '原版服务端',
    'mc.serverCore.vanillaCoreDesc': 'Minecraft 官方原版服务端核心。',
    'mc.serverCore.bedrockCore': '基岩版服务端',
    'mc.serverCore.bedrockCoreDesc': '用于基岩版（手机版）的服务端核心。',
    'mc.serverCore.proxyCore': '代理服务端',
    'mc.serverCore.proxyCoreDesc': '用于连接多个服务器的代理核心。',

    // 通用
    'common.confirm': '确认',
    'common.error': '错误',
    'common.notice': '提示',

    // 主题切换
    'theme.switcher': '主题',
    'theme.light': '浅色',
    'theme.dark': '深色',
    'theme.auto': '自动',

    // 服务归属信息
    'mc.serverCore.attribution': '本服务由<a href="https://github.com/MSLTeam" target="_blank" class="link-secondary">MSLTeam</a>提供，欢迎使用我们的<a href="https://www.mslmc.cn/" target="_blank" class="link-secondary">MSL开服器</a>，下载API来源<a href="https://www.mslmc.cn/docs/other/msl-mirrors.html" target="_blank" class="link-secondary">MSL-API-V3</a>。',

    // 页脚
    'footer.copyright': 'Copyright © MSLTeam 2021-2025 All Right Received.',
    'footer.icp': '粤ICP备2023094648号-2',
};